import { Countries } from './../../../utils/countries-enum';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';

export class IndiaManifest {
  da: DynamicArrayGenerator;

  constructor() {
    this.da = new DynamicArrayGenerator();
  }

  public getINDManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'company-names',
        'module': 'GlobalModule'
      },
      {
        'key': 'round-to-rupees',
        'module': 'IndiaModule'
      },
      {
        'key': 'customer-approval-documents',
        'module': 'GlobalModule'
      },
      {
        'key': 'google-address-form',
        'module': 'IndiaModule'
      },
      {
        'key': 'tax-info',
        'module': 'IndiaModule'
      },
      {
        'key': 'disbursements',
        'module': 'IndiaModule'
      },
      {
        'key': 'represented-party-address-google',
        'module': 'IndiaModule'
      },
      {
        'key': 'supplier-type',
        'module': 'IndiaModule'
      },
      {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      },
      {
        'key': 'absorbtion-termination-date',
        'module': 'IndiaModule'
      },
      {
        'key': 'miq-property-id',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'ship-to-address',
        'module': 'IndiaModule'
      },
      {
        'key': 'edp-account-contact',
        'module': 'GlobalModule'
      },
      {
        'key': 'autocomplete-multiple-columns',
        'module': 'GlobalModule',
      },
      {
        'key': 'invoice-google-address-form',
        'module': 'IndiaModule'
      },
      {
        'key': 'legal-details',
        'module': 'IndiaModule'
      },
      {
        'key': 'aml-checklist',
        'module': 'GlobalModule'
      },
      {
        'key': 'valuation-fee',
        'module': 'IndiaModule'
      },
      {
        'key': 'lob',
        'module': 'IndiaModule'
      },
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.India);
  }
}
